/* ll-cart.js — de winkelwagen.
 *
 * Hybride, zoals op The Hills: Horizons `<theme-drawer>` doet het openen en
 * sluiten, de klemring en het schuifslot; wij doen de inhoud en de mutaties.
 *
 * DRIE DINGEN DIE HIER ANDERS MOESTEN DAN JE ZOU DENKEN
 *
 * 1. De knop in de kop is van Horizon en opent Horizons eigen lade. Die nemen
 *    we in de VANGFASE over met `stopImmediatePropagation()`, want een gewone
 *    listener komt te laat: Horizons `on:click` staat op het element zelf.
 * 2. Horizon vuurt geen eigen wagengebeurtenis in `ThemeEvents`. Wel Shopify's
 *    `shopify:cart:lines-update`, en daar ben ik mee begonnen — maar GEMETEN:
 *    die vuurt TE VROEG. Op het moment dat hij afgaat gaf `/cart.js` nog 0
 *    terwijl er net iets was toegevoegd, dus de lade hertekende zichzelf naar
 *    de oude stand. Daarom nu de route van The Hills: `window.fetch` omlappen
 *    en pas hertekenen als het antwoord op de wagenmutatie ECHT binnen is.
 *    Dan is de server bij, per definitie.
 * 3. Hertekenen gaat over het NETWERK: `/cart/change.js` met `sections=<id>`
 *    geeft onze eigen sectie terug. We wisselen alleen de binnenkant om, zodat
 *    de <dialog> blijft leven en de lade niet dichtklapt.
 */
(() => {
  if (window.__llWagen) return;
  window.__llWagen = true;

  const LADE = 'll-wagen-lade';

  const lade = () => document.getElementById(LADE);
  const binnen = () => document.querySelector('[data-ll-wagen]');
  const waas = () => document.querySelector('.ll-wagen__waas');

  /* De sectie-id nooit intypen: hij verandert per winkel en per sjabloon. */
  function sectieId() {
    const w = lade()?.closest('[id^="shopify-section-"]');
    return w ? w.id.replace('shopify-section-', '') : null;
  }

  function open() {
    const l = lade();
    if (!l) return;
    l.querySelector('dialog')?.style.removeProperty('--ll-uit-van');
    l.open?.();
    waas()?.classList.add('is-open');
  }

  /* ── Onderbreken zonder sprong ──────────────────────────────────────────
     De bron gebruikt een TRANSITION, en die keert onderweg gewoon om: druk je
     halverwege het openen op sluiten, dan glijdt de lade terug vanaf waar hij
     op dat moment staat. Horizon gebruikt ANIMATIES, en een animatie begint
     altijd bij zijn eerste sleutelbeeld — de lade sprong dus eerst naar
     helemaal open en schoof daarna pas weg.

     Horizon vuurt `theme-drawer:close` voordat hij de sluitklasse zet, dus op
     dat moment staat de openingsanimatie nog te draaien en kunnen we de stand
     uitlezen. Die zetten we als beginpunt van de sluitanimatie. */
  document.addEventListener('theme-drawer:close', (e) => {
    if (e.target?.id !== LADE) return;
    const dlg = e.target.querySelector('dialog');
    if (!dlg) return;
    try {
      const m = new DOMMatrixReadOnly(getComputedStyle(dlg).transform);
      dlg.style.setProperty('--ll-uit-van', Math.round(m.m41 * 100) / 100 + 'px');
    } catch (err) {}
  }, true);
  function dicht() {
    const l = lade();
    l?.close?.();
    waas()?.classList.remove('is-open');
    /* Vangnet. Horizon wacht op het EINDE van de sluitanimatie voordat hij het
       venster echt dichtdoet, en in een tabblad op de achtergrond loopt een
       animatie helemaal niet. Sluit je de wagen en stap je meteen naar een
       ander tabblad, dan staat de lade er bij terugkomst nog. Het slot en het
       `open`-kenmerk zijn dan al weg, dus we halen alleen het venster nog weg.
       500ms is ruim boven de 300ms van de animatie: bij een gewone sluiting
       vuurt dit nooit. */
    setTimeout(() => {
      const dlg = l?.querySelector?.('dialog');
      if (dlg && dlg.open && !l.hasAttribute('open')) { try { dlg.close(); } catch (err) {} }
    }, 500);
  }

  /* ── De knop in de kop overnemen ──────────────────────────────────────── */
  document.addEventListener(
    'click',
    (e) => {
      const knop = e.target.closest?.(
        '[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"], a[href$="/cart"]'
      );
      if (!knop) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    },
    true
  );

  document.addEventListener('click', (e) => {
    if (e.target.closest?.('[data-ll-w-sluit]')) { e.preventDefault(); dicht(); return; }

    /* NAAST de wagen klikken ging anders dan op het kruisje drukken, en dat zag
       de eigenaar: via het kruisje vervaagt de waas mee met de lade, via de
       waas bleef hij op vol staan tot de lade er al uit was en vervaagde hij
       pas daarna. Gemeten, dekking van de waas per frame:

         kruisje   0,99 -> 0 tussen 15ms en 260ms, tegelijk met de lade
         ernaast   1 tot 313ms, dan pas van 0,98 naar 0 tussen 362 en 613ms

       De oorzaak: onze waas ligt op laag 40 en Horizons `<dialog>` erboven, dus
       een klik ernaast raakt zijn dialoog en niet onze waas — `data-ll-w-sluit`
       wordt dan nooit geraakt. Horizon sluit vervolgens zelf, maar hij wacht
       eerst zijn EIGEN sluitanimatie af en stuurt pas daarna zijn `close`. Onze
       waas hangt aan dat signaal en liep dus een animatie achter.

       Een klik op de dialoog ZELF (dus niet op iets erin) is per definitie een
       klik naast het paneel. Die pakken we hier af en sturen we door dezelfde
       `dicht()` als het kruisje. */
    const l = lade();
    const dlg = l?.querySelector?.('dialog');
    if (dlg && e.target === dlg) { dicht(); }
  });

  /* Escape sloot eerst alleen de waas en liet de lade openstaan. Op het
     bureaublad opent Horizon met `show()` in plaats van `showModal()`, en dan
     sluit de browser een dialoog NIET vanzelf op Escape. Dus zelf sluiten. */
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') dicht(); });

  /* Wat er ook sluit — onze knop, Escape, Horizons klemring, een terugknop —
     de waas moet mee. Anders blijft er een doorzichtige laag over het hele
     scherm liggen die elke klik opvangt: het scherm lijkt dan bevroren. */
  document.addEventListener('close', (e) => {
    if (e.target?.closest?.('#' + LADE)) waas()?.classList.remove('is-open');
  }, true);

  /* ── Horizons eigen wagenlade onschadelijk maken ────────────────────────
     DIT was het niet-meer-kunnen-scrollen, en het zat subtieler dan gedacht.

     Als je op het tasje drukt gaat ONZE lade open, maar Horizons eigen
     `<theme-drawer id="cart-drawer">` gaat OOK open — zijn knop luistert niet
     op een plek die wij in de vangfase kunnen afvangen. Zijn lade staat bij ons
     op `display:none`, dus je ziet er niets van, en in de eerste versie sloot
     ik alleen zijn `<dialog>`. Dat is te weinig: het element `<theme-drawer>`
     houdt dan zijn `open`-kenmerk, en daarmee blijft
     `lockScroll` staan. Horizon zet bij een slot `scroll-lock` op `<html>`, en
     `html[scroll-lock] .page-wrapper { overflow: hidden }` — op het bureaublad
     is die page-wrapper de schuiver. Gevolg: je komt uit de wagen en de pagina
     schuift niet meer. Gemeten op 390 (`scroll-lock` bleef staan) en op 1440
     (de pagina bleef 480px opzij gedrukt staan).

     Dus: `close()` op het ELEMENT aanroepen. Dan doet Horizon zelf zijn
     `unlockScroll`, haalt hij de klemring weg en zet hij de pagina terug. */
  function horizonLadeDicht() {
    const lade = document.querySelector('theme-drawer#cart-drawer');
    if (lade && lade.hasAttribute('open')) {
      try { lade.close(); } catch (err) {}
    }
  }
  function bewaakHorizonLade() {
    const lade = document.querySelector('theme-drawer#cart-drawer');
    if (!lade) return false;
    horizonLadeDicht();
    new MutationObserver(horizonLadeDicht).observe(lade, { attributes: true, attributeFilter: ['open'] });
    return true;
  }
  if (!bewaakHorizonLade()) {
    /* De lade komt uit een aparte sectie en staat er soms nog niet op het
       moment dat dit script draait. */
    const wacht = new MutationObserver(() => { if (bewaakHorizonLade()) wacht.disconnect(); });
    wacht.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => wacht.disconnect(), 10000);
  }

  /* ── Hertekenen ───────────────────────────────────────────────────────── */
  const wacht = (ms) => new Promise((r) => setTimeout(r, ms));

  async function haalSectie(id) {
    const r = await fetch(`${location.pathname}?sections=${id}`, { credentials: 'same-origin' });
    const j = await r.json();
    const doos = document.createElement('div');
    doos.innerHTML = j[id] || '';
    return doos.querySelector('[data-ll-wagen]');
  }

  let bezig = false;
  async function herteken() {
    const id = sectieId();
    if (!id || bezig) return;
    bezig = true;
    try {
      /* Een vangnet, geen hoofdmechanisme: we hertekenen pas NA het antwoord
         op de wagenmutatie, dus de server is bij. Blijkt het getal toch te
         verschillen van `/cart.js`, dan nog twee pogingen — dat vangt een
         trage verbinding op zonder een vaste wachttijd te verzinnen. */
      const echt = await fetch('/cart.js', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((c) => c.item_count)
        .catch(() => null);

      let nieuw = null;
      for (const pauze of [0, 250, 600]) {
        if (pauze) await wacht(pauze);
        nieuw = await haalSectie(id);
        if (!nieuw) continue;
        if (echt === null || parseInt(nieuw.dataset.aantal, 10) === echt) break;
      }
      const oud = binnen();
      if (nieuw && oud) oud.replaceWith(nieuw);
      /* De melding staat HIER en niet bij elke knop apart: zo vuurt hij ook
         als Horizons eigen koopknop de wagen verandert. De trapmeter op de
         productpagina hangt eraan. */
      document.querySelectorAll('[data-ll-w-baan]').forEach((b) => { b.__llIndex = 0; zetPijlen(b); });
      document.dispatchEvent(new CustomEvent('ll:wagen-gewijzigd', { detail: { aantal: echt } }));
    } catch (e) {
      /* stil: een mislukte hertekening mag de wagen niet slopen */
    } finally {
      bezig = false;
    }
  }

  async function wijzig(regel, aantal) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-ll-wagen': '1' },
      body: JSON.stringify({ line: regel, quantity: aantal }),
      credentials: 'same-origin',
    });
    await herteken();
  }

  /* ── Verwijderen, variant, upsell ────────────────────────────────────────
     De aantalknoppen zijn eruit op verzoek van de eigenaar: een regel gaat er
     in zijn geheel uit via het kruisje. `wijzig(regel, 0)` is dus alles wat
     hier nog over is. */
  document.addEventListener('click', async (e) => {
    const weg = e.target.closest?.('[data-ll-w-weg]');
    if (!weg) return;
    e.preventDefault();
    const regel = parseInt(weg.dataset.line, 10);
    if (!regel) return;
    wijzig(regel, 0);
  });

  /* Elke productoptie heeft nu een eigen vakje (Colour, Size, ...). Het script
     leest ALLE vakjes van die regel, zoekt de combinatie op in het JSON-blokje
     dat naast de vakjes staat, en wisselt de regel om. Shopify kan een variant
     niet in één stap wisselen: eerst de oude regel op 0, dan de nieuwe erbij. */
  document.addEventListener('change', async (e) => {
    const vakje = e.target.closest?.('[data-ll-w-optie]');
    if (!vakje) return;
    const doos = vakje.closest('[data-ll-w-opties]');
    if (!doos) return;
    const regel = parseInt(doos.dataset.line, 10);
    const aantal = parseInt(doos.dataset.lineQty || '1', 10);
    const waarden = [...doos.querySelectorAll('[data-ll-w-optie]')].map((s) => s.value);

    let varianten = [];
    try { varianten = JSON.parse(doos.querySelector('[data-ll-w-varianten]').textContent); } catch (err) {}
    const treffer = varianten.find(
      (v) => v.o.length === waarden.length && v.o.every((w, i) => w === waarden[i])
    );
    /* Bestaat de combinatie niet of is hij uitverkocht, dan hertekenen we
       gewoon: de vakjes springen terug naar wat er echt in de wagen ligt. */
    if (!treffer || !treffer.a) { await herteken(); return; }

    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'x-ll-wagen': '1' },
      body: JSON.stringify({ line: regel, quantity: 0 }), credentials: 'same-origin',
    });
    await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'x-ll-wagen': '1' },
      body: JSON.stringify({ id: treffer.id, quantity: aantal }), credentials: 'same-origin',
    });
    await herteken();
  });

  document.addEventListener('click', async (e) => {
    const toe = e.target.closest?.('[data-ll-w-upstoevoegen]');
    if (!toe) return;
    e.preventDefault();
    const kaart = toe.closest('.ll-wupsk');
    const kiezer = kaart?.querySelector('[data-ll-w-upsvariant]');
    const id = parseInt(kiezer?.value || toe.dataset.variantId, 10);
    if (!id) return;
    toe.disabled = true;
    await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'x-ll-wagen': '1' },
      body: JSON.stringify(Object.assign({ id, quantity: 1 }, kaart && kaart.dataset.upKaart ? { properties: { _upsell: `kaart-${kaart.dataset.upKaart}-groep-${upGroep()}-week-${UPWEEK}` } } : {})), credentials: 'same-origin',
    });
    await herteken();
  });

  /* ── De pijltjes van de aanbevelingen ──────────────────────────────────────
     Eerst stond hier `scrollBy` met `behavior:'smooth'`. Snel klikken liep
     daarop stuk: elke klik las `scrollLeft` UIT terwijl de vorige beweging nog
     liep, dus je sprong naar een halve kaart, de scroll-snap trok terug, en
     dat is het geglitch. Nu houdt de baan zijn eigen positie bij als getal, en
     is die klemd tussen 0 en de laatste kaart. De uitgelezen scrollpositie
     wordt alleen gebruikt als de gebruiker zelf geveegd heeft. */
  function stapGrootte(baan) {
    const eerste = baan.firstElementChild;
    return eerste ? eerste.getBoundingClientRect().width : baan.clientWidth;
  }
  function zetPijlen(baan) {
    const wups = baan.closest('.ll-wups');
    if (!wups) return;
    const laatste = Math.max(0, baan.children.length - 1);
    const i = baan.__llIndex || 0;
    wups.querySelector('[data-ll-w-terug]')?.toggleAttribute('disabled', i <= 0);
    wups.querySelector('[data-ll-w-verder]')?.toggleAttribute('disabled', i >= laatste);
  }
  function schuif(baan, richting) {
    const stap = stapGrootte(baan);
    if (!stap) return;
    const laatste = Math.max(0, baan.children.length - 1);
    const nu = baan.__llIndex == null ? Math.round(baan.scrollLeft / stap) : baan.__llIndex;
    const doel = Math.min(laatste, Math.max(0, nu + richting));
    baan.__llIndex = doel;
    zetPijlen(baan);
    baan.scrollTo({ left: doel * stap, behavior: 'smooth' });
  }

  document.addEventListener('click', (e) => {
    const terug = e.target.closest?.('[data-ll-w-terug]');
    const verder = e.target.closest?.('[data-ll-w-verder]');
    if (!terug && !verder) return;
    e.preventDefault();
    const baan = (terug || verder).closest('.ll-wups')?.querySelector('[data-ll-w-baan]');
    if (baan) schuif(baan, terug ? -1 : 1);
  });

  /* Veegt de gebruiker zelf, dan is onze telling niet meer waar. Na het
     uitrollen lezen we hem opnieuw uit. */
  document.addEventListener('scroll', (e) => {
    const baan = e.target;
    if (!baan?.matches?.('[data-ll-w-baan]')) return;
    clearTimeout(baan.__llTik);
    baan.__llTik = setTimeout(() => {
      const stap = stapGrootte(baan);
      if (stap) { baan.__llIndex = Math.round(baan.scrollLeft / stap); zetPijlen(baan); }
    }, 120);
  }, true);

  /* ── Elke wagenmutatie opvangen ───────────────────────────────────────────
     Horizons eigen knoppen (productpagina, snelkoop, plakbalk) gaan allemaal
     over `/cart/add.js` en verwanten. Door `window.fetch` om te lappen zien we
     ze allemaal, en pas NADAT de server heeft geantwoord — dat is het verschil
     met de gebeurtenis, die te vroeg komt.

     Onze eigen aanroepen dragen `x-ll-wagen: 1` zodat ze hier niet nog een
     keer een hertekening starten. */
  const echteFetch = window.fetch.bind(window);
  const WAGEN = /\/cart\/(add|change|update|clear)/;
  /* ÉÉN RONDE BIJ TOEVOEGEN (12 okt 2026). De lade ging open met de oude stand
     ("Your bag is empty") en werkte zich ~1 s later bij, na /cart.js en de sectie.
     Gemeten op een nagebootste iPhone 13: open 668 ms, product pas op 1.723 ms.
     Shopify geeft onze sectie mee als hij in `sections` van /cart/add staat; dan
     openen we de lade pas als de inhoud er al in zit. Lukt dat niet, de oude weg. */
  function metOnzeSectie(opties, id) {
    try {
      const b = opties && opties.body;
      if (!b) return opties;
      if (b instanceof FormData || b instanceof URLSearchParams) {
        const s = b.get('sections');
        b.set('sections', s ? `${s},${id}` : id);
        return opties;
      }
      if (typeof b === 'string' && b.trim().startsWith('{')) {
        const j = JSON.parse(b);
        if (Array.isArray(j.sections)) j.sections = [...j.sections, id];
        else j.sections = j.sections ? `${j.sections},${id}` : id;
        return { ...opties, body: JSON.stringify(j) };
      }
    } catch (e) {
      /* stil: dan gaat de aanvraag zoals hij was */
    }
    return opties;
  }

  function zetNieuw(html) {
    if (!html) return false;
    const doos = document.createElement('div');
    doos.innerHTML = html;
    const nieuw = doos.querySelector('[data-ll-wagen]');
    const oud = binnen();
    if (!nieuw || !oud) return false;
    oud.replaceWith(nieuw);
    document.querySelectorAll('[data-ll-w-baan]').forEach((b) => { b.__llIndex = 0; zetPijlen(b); });
    document.dispatchEvent(new CustomEvent('ll:wagen-gewijzigd', { detail: { aantal: parseInt(nieuw.dataset.aantal, 10) } }));
    return true;
  }

  window.fetch = async function (bron, opties) {
    const url0 = typeof bron === 'string' ? bron : bron && bron.url;
    const eigen0 = opties && opties.headers && opties.headers['x-ll-wagen'];
    const id = url0 && /\/cart\/add/.test(url0) && !eigen0 ? sectieId() : null;
    if (id) opties = metOnzeSectie(opties, id);
    const antwoord = await echteFetch(bron, opties);
    try {
      const url = url0;
      const eigen = eigen0;
      if (id && antwoord.ok) {
        let gelukt = false;
        try {
          const j = await antwoord.clone().json();
          gelukt = zetNieuw(j && j.sections && j.sections[id]);
        } catch (e) {
          gelukt = false;
        }
        open();
        if (!gelukt) herteken();
        return antwoord;
      }
      if (url && WAGEN.test(url) && antwoord.ok && !eigen) {
        const toegevoegd = /\/cart\/add/.test(url);
        /* EERST openen, dan hertekenen. Het stond andersom, en dan gebeurde er
           na "Add to cart" eerst niets: `herteken()` haalt `/cart.js` op én de
           sectie, twee keer over het netwerk, en pas daarna schoof de lade
           binnen. De bron doet het precies andersom — `openCart()` staat daar
           los van het hertekenen (`cart:change` -> openen, en het bijwerken
           loopt ernaast). De lade toont een tel lang de vorige stand en werkt
           zichzelf onder je bij, en dat is wat "meteen open" voelt. */
        if (toegevoegd) open();
        herteken();
      }
    } catch (e) {
      /* een fout in het meekijken mag het echte verzoek nooit raken */
    }
    return antwoord;
  };


  /* ── 3 nov 2026: de accessoire-upsell kiest 5 kaarten ──────────────────────────────────────────────
     De Liquid zet alle passende accessoires uit cart-extras in de baan (data-up-extras). Hier kiezen we er
     vijf: kaart 1-4 zonder maatkeuze, kaart 5 met een maat. Elke bezoeker zit vast in één van vier groepen;
     elke 7 dagen schuift de volgorde één plek op. Het nummer van de kaart gaat als verborgen eigenschap
     (_upsell) mee naar de bestelling, zodat we per kaart kunnen tellen. */
  const UPWEEK = Math.floor(Date.now() / 604800000);
  function upGroep() {
    let g = null;
    try { g = localStorage.getItem('ll_up_groep'); } catch (e) {}
    if (g === null || !/^[0-3]$/.test(g)) { g = String(Math.floor(Math.random() * 4)); try { localStorage.setItem('ll_up_groep', g); } catch (e) {} }
    return Number(g);
  }
  function upKiezen() {
    document.querySelectorAll('[data-ll-w-baan][data-up-extras]').forEach((baan) => {
      const alle = [...baan.querySelectorAll('.ll-wupsk')].sort((a, b) => Number(a.dataset.upPid) - Number(b.dataset.upPid));
      const draai = (a, n) => (a.length ? a.slice(n % a.length).concat(a.slice(0, n % a.length)) : a);
      const g = upGroep();
      const eenTik = draai(alle.filter((k) => k.dataset.upMaat !== '1'), g * 4 + UPWEEK);
      const metMaat = draai(alle.filter((k) => k.dataset.upMaat === '1'), g + UPWEEK);
      const keuze = eenTik.slice(0, 4);
      if (metMaat.length) keuze.push(metMaat[0]);
      for (const k of eenTik.slice(4).concat(metMaat.slice(1))) { if (keuze.length >= 5) break; keuze.push(k); }
      alle.forEach((k) => { if (!keuze.includes(k)) k.remove(); });
      keuze.forEach((k, i) => { k.dataset.upKaart = i + 1; baan.appendChild(k); });
      baan.__llIndex = 0; zetPijlen(baan);
      const wups = baan.closest('.ll-wups'); if (wups && !keuze.length) wups.hidden = true;
    });
  }
  document.addEventListener('ll:wagen-gewijzigd', upKiezen);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upKiezen); else upKiezen();

  /* ── Horizons opgeslagen open-stand opruimen ──────────────────────────────
     Horizon bewaart een openstaande lade in sessionStorage en opent hem op de
     VOLGENDE pagina opnieuw. Op The Hills stond de wagen daardoor als venster
     over elke pagina, met de body op slot. `no-persist` op het element dekt
     onze lade; deze regel ruimt op wat er nog van een vorige sessie staat. */
  try { sessionStorage.removeItem('theme-drawer-open'); } catch (e) {}
})();
